import CalendarEvent from '@/modules/calendar/model/CalendarEvent'
import {Module} from 'vuex';
import {RootState} from '@/store/types';
import mutations from '@/modules/calendar/store/mutations'
import actions from '@/modules/calendar/store/actions'
import getters from '@/modules/calendar/store/getters'
import CalendarEventType from '@/modules/calendar/model/CalendarEventType';

export interface CalendarState {
    /**
     * Mapa con los eventos por mes
     */
    calendarEvents: CalendarEvent[],

    /**
     * Evento de calendario actualmente seleccionado por el usuario
     */
    currentCalendarEvent: CalendarEvent,

    /**
     * Indica si el usuario esta creando un nuevo evento de calendario
     */
    creatingCalendarEvent: boolean,

    /**
     * Lista con los tipos de evento de calendario
     */
    calendarEventTypes: CalendarEventType[],

    /**
     * Tipo de evento de calendario actualmente seleccionado por el usuario
     */
    currentCalendarEventType: CalendarEventType,
}

const module: Module<CalendarState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    getters,
    state: {
        calendarEvents: [],
        currentCalendarEvent: new CalendarEvent(),
        creatingCalendarEvent: false,
        calendarEventTypes: [],
        currentCalendarEventType: new CalendarEventType(),
    },
}

export default module
